import styled from 'styled-components'
import CodeMirror from 'react-codemirror2'

export default styled(CodeMirror)`
  cursor: text;
  height: 100%;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/organisms/MainEditor/CodeMirror.js